// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3T7li","actionsCol":"EnrolledClinics_actionsCol__QmbXK"};